import React from 'react';
import NotificationIcon from '@portal/assets/svg/home-buttons/ic_bell.svg?react';
import { useTheme } from '@material-ui/core';
import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import ThemedText from '@portal/components/ThemedText/ThemedText';

export interface PanelContentHeaderProps {
  pageTitle?: string;
  pageSubtitle?: string;
  pageDescription?: string;
  notification?: boolean;
  after?: React.ReactNode;
  titleAdornment?: React.ReactNode;
  button?: {
    label: React.ReactNode;
    action: () => void;
  };
  top?: React.ReactNode;
}

const PanelContentHeader = ({
  after,
  notification,
  pageDescription,
  pageTitle,
  pageSubtitle,
  titleAdornment,
  button,
  top,
}: PanelContentHeaderProps) => {
  const { palette } = useTheme();

  return (
    <div className="panel-content-header">
      {top}
      <div className="panel-content-header__inner">
        <div className="panel-content-header__inner__title">
          <div
            className={
              pageTitle
                ? 'panel-content-header__inner__title__text'
                : 'panel-content-header__inner__title__no-text'
            }
          >
            <ThemedText variant="h2">{pageTitle}</ThemedText>
            {titleAdornment ? (
              <ThemedText className="panel-content-header__inner__title__text__adornment">
                {titleAdornment}
              </ThemedText>
            ) : null}
            {notification ? (
              <div className="panel-content-header__inner__notification">
                <NotificationIcon fill={palette.secondary.main} />
              </div>
            ) : null}
            <div className={button ? '' : 'panel-content-header__no-button'}>
              <AdvancedButton
                customStyles={{ borderRadius: 4 }}
                onClick={button?.action}
                text={typeof button?.label === 'string' ? button.label : ''}
              />
            </div>
          </div>
        </div>
        {pageSubtitle ? (
          <div className="panel-content-header__inner__subtitle">
            <ThemedText
              variant="body"
              className="panel-content-header__inner__subtitle__text"
            >
              {pageSubtitle}
            </ThemedText>
          </div>
        ) : null}
        <div className="panel-content-header__inner__description">
          <ThemedText variant="body" color="gray">
            {pageDescription}
          </ThemedText>
          {after}
        </div>
      </div>
    </div>
  );
};

export default PanelContentHeader;
